import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["value", "size", "thickness", "enableHover", "children", "label"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { CircularProgress as MuiCircularProgress } from "@mui/material";
import { Typography, RaiseColors, makeStyles } from "componentLibrary";
import classNames from "classnames";
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var ProgressCircle = function ProgressCircle(_ref) {
  var value = _ref.value,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 50 : _ref$size,
    _ref$thickness = _ref.thickness,
    thickness = _ref$thickness === void 0 ? 4 : _ref$thickness,
    _ref$enableHover = _ref.enableHover,
    enableHover = _ref$enableHover === void 0 ? false : _ref$enableHover,
    children = _ref.children,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = makeStyles(function () {
    return {
      container: {
        position: "relative",
        display: "inline-flex",
        height: size,
        width: size
      },
      content: {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap",
        alignContent: "center"
      },
      innerCircle: {
        color: RaiseColors.gray100,
        fill: RaiseColors.white,
        // This needs to be overriden to create a innercircle that is center aligned with the progress circle.
        // To achieve the centering effect, the innerCircle's radius should be the same as the outer progress circle.
        // 44 is the SIZE constant used for the default MUI component.
        // https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/CircularProgress/CircularProgress.js
        r: (44 - thickness) / 2
      },
      hover: {
        cursor: "pointer",
        "&:hover $innerCircle": {
          color: RaiseColors.gray200,
          fill: RaiseColors.grayNav
        }
      }
    };
  })();

  // Color Definitions: https://www.figma.com/file/Bxdi6IEuknq3nqtLVjTOtj/Lease-Administration?node-id=1501%3A0
  var getProgressColor = function getProgressColor(value) {
    if (value > 0 && value < 25) {
      // Underutilization 0 < x < 25%
      return RaiseColors.warning;
    } else if (value >= 25 && value <= 70) {
      // All good here 25% <= x <= 70%
      return RaiseColors.shamrock;
    } else if (value > 70 && value < 100) {
      // It's getting cramped > 70%
      return RaiseColors.peach;
    } else if (value === 100) {
      // Lastly we are at a 100.
      return RaiseColors.alarm;
    }
    return "transparent";
  };
  var percentage = label ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Typography, {
      variant: "h4",
      weight: "semibold",
      color: RaiseColors.black,
      children: [value, "%"]
    }), /*#__PURE__*/_jsx(Typography, {
      variant: "paragraph_small",
      style: {
        color: RaiseColors.black
      },
      children: label
    })]
  }) : /*#__PURE__*/_jsxs(Typography, {
    variant: "paragraph_small",
    weight: "semibold",
    color: RaiseColors.black,
    children: [value, "%"]
  });
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": "progress-circle-outer-container",
    className: classNames(classes.container, _defineProperty({}, classes.hover, enableHover)),
    children: [/*#__PURE__*/_jsxs("div", {
      "data-testid": "progress-circle-inner-container",
      style: {
        position: "relative"
      },
      children: [/*#__PURE__*/_jsx(MuiCircularProgress, {
        variant: "determinate",
        size: size,
        thickness: 2,
        value: 100,
        classes: {
          circle: classes.innerCircle
        }
      }), /*#__PURE__*/_jsx(MuiCircularProgress, _objectSpread({
        "data-testid": "progress-circle",
        style: {
          position: "absolute",
          left: 0,
          color: getProgressColor(value !== null && value !== void 0 ? value : 0)
        },
        variant: "determinate",
        size: size,
        thickness: thickness,
        value: value
      }, props))]
    }), /*#__PURE__*/_jsx("div", {
      className: classes.content,
      children: children !== null && children !== void 0 ? children : percentage
    })]
  });
};
export default ProgressCircle;